export const parseQueryId = <T extends number = number>(id: string[] | string | undefined): T =>
  (typeof id === 'string' ? parseInt(id) : 0) as T
